import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { WebsiteConstants } from '.././global/website-constants';
@Injectable({
  providedIn: 'root'
})
export class UploadUserPhotoService {
  private masterUrl = WebsiteConstants.MasterUrl;
  UploadUserPhotosUrl = this.masterUrl+"UploadUserPhotos/UploadUserPhotos"
  constructor(private http : HttpClient) { }
  UploadUserPhotosPost(body,headers)
  {
    return this.http.post(this.UploadUserPhotosUrl,body,headers)
  }
}

